var classes = {
  "root": "m_e5262200",
  "indicator": "m_760d1fb1",
  "processing": "m_885901b1"
};
export { classes as default };